module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-264.9b1523ff.jpg";